"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxTableHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("../ProductBoxTable.scss");
var ProductBoxTableHeader = function ProductBoxTableHeader(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      sku: 'SKU',
      manufacturerSku: 'Manufacturer Product ID',
      title: 'Title',
      price: 'Price',
      stock: 'Stock'
    } : _ref$text,
    className = _ref.className;
  var cellClassName = (0, _classnames["default"])('cds-ProductBoxTable-HeadCell');
  return /*#__PURE__*/_react["default"].createElement("thead", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    className: cellClassName
  }), /*#__PURE__*/_react["default"].createElement("th", {
    className: cellClassName
  }, text.sku), /*#__PURE__*/_react["default"].createElement("th", {
    className: cellClassName
  }, text.manufacturerSku), /*#__PURE__*/_react["default"].createElement("th", {
    className: cellClassName
  }, text.title), /*#__PURE__*/_react["default"].createElement("th", {
    className: (0, _classnames["default"])(cellClassName, 'cds-ProductBoxTable-HeadCell--Price'),
    dangerouslySetInnerHTML: {
      __html: text.price
    }
  }), /*#__PURE__*/_react["default"].createElement("th", {
    className: (0, _classnames["default"])(cellClassName, 'cds-ProductBoxTable-HeadCell--Stock')
  }, text.stock), /*#__PURE__*/_react["default"].createElement("th", {
    className: cellClassName
  })));
};
exports.ProductBoxTableHeader = ProductBoxTableHeader;